// La API conserva el historial del mismo contacto y conexión, aunque sus
// mensajes pertenezcan a tickets anteriores. El socket debe respetar ese alcance.
export const belongsToConversation = (message, conversation) => {
  if (!message || !conversation) return false;
  const validId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const sameId = (a, b) => validId(a) && validId(b) && Number(a) === Number(b);

  if (sameId(message.ticketId, conversation.id)) return true;

  const origin = message.ticket;
  return Boolean(
    origin &&
    sameId(origin.id, message.ticketId) &&
    sameId(origin.contactId, conversation.contactId) &&
    sameId(origin.whatsappId, conversation.whatsappId) &&
    typeof origin.isGroup === "boolean" &&
    origin.isGroup === conversation.isGroup
  );
};
